import { Navigate } from "react-router-dom";
import Layout from "./Layout/Layout";
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getCurrentUser } from '../slice/AuthSlice';
import Loader from './Loader/Loader';

const ProtectedRoute = ({ element, isAuthenticated, path, isAdminOnly, noLayout }) => {
  const dispatch = useDispatch();
  const { isAdmin, user } = useAuth();
  const authStatus = useSelector((state) => state.auth.status);
  
  // Dispatch getCurrentUser if not already loading/loaded
  useEffect(() => {
    if ((authStatus === '' || authStatus === 'idle') && !user) {
      dispatch(getCurrentUser());
    }
  }, [dispatch, authStatus, user]);
  
  // Wait for auth to load before checking admin status
  // This prevents redirecting admin users on page refresh
  if (isAdminOnly) {
    // If auth is still loading or user is not yet loaded, show loader
    if (authStatus === 'loading' || (!user && authStatus !== 'failed')) {
      return <Loader />;
    }
    // Only redirect if user is loaded and is not admin
    if (!isAdmin) {
      return <Navigate to="/matter" />;
    }
  }
  
  if (!isAuthenticated) return <Navigate to={path} />;
  return noLayout ? element : <Layout>{element}</Layout>;
};

export default ProtectedRoute;
ProtectedRoute.propTypes = {
  element: PropTypes.node.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  isAdminOnly: PropTypes.bool,
  noLayout: PropTypes.bool,
};